module.exports = __webpack_public_path__ + "assets/img/login-email.65360d9.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/login-email.png
// module id = Nvjk
// module chunks = 50